import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { useState } from 'react';
import Icon from '../Icon/Icon.js';
import { PictureReplacement, Picture as Picture$2 } from './style.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { MEDIA_CAMERA_UNAVAILABLE } from '../../icons/MEDIA_CAMERA_UNAVAILABLE.js';

var _excluded = ["sources", "className", "errorIcon", "lazy", "alt", "fallbackSrc"],
  _excluded2 = ["srcSet", "type", "media"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultErrorIcon = {
  path: MEDIA_CAMERA_UNAVAILABLE,
  size: 'xl',
  sizeMobile: 'l'
};
var Picture = function Picture(_ref) {
  var sources = _ref.sources,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? null : _ref$className,
    _ref$errorIcon = _ref.errorIcon,
    errorIcon = _ref$errorIcon === void 0 ? defaultErrorIcon : _ref$errorIcon,
    _ref$lazy = _ref.lazy,
    lazy = _ref$lazy === void 0 ? false : _ref$lazy,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? null : _ref$alt,
    _ref$fallbackSrc = _ref.fallbackSrc,
    fallbackSrc = _ref$fallbackSrc === void 0 ? null : _ref$fallbackSrc,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState({
      hasBrokenImageUrl: !sources || sources.length <= 0
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var src;
  if (fallbackSrc) {
    src = fallbackSrc;
  } else if (sources && sources.length > 0) {
    var lastSource = sources[sources.length - 1];
    src = lastSource.srcSet || '';
  } else {
    src = '';
  }
  var onErrorCallback = function onErrorCallback() {
    setState({
      hasBrokenImageUrl: true
    });
  };
  if (state.hasBrokenImageUrl) {
    return /*#__PURE__*/jsx(PictureReplacement, {
      className: className,
      children: /*#__PURE__*/jsx(Icon, {
        className: "sg-picture-icon",
        path: (errorIcon === null || errorIcon === void 0 ? void 0 : errorIcon.path) || defaultErrorIcon.path,
        size: (errorIcon === null || errorIcon === void 0 ? void 0 : errorIcon.size) || defaultErrorIcon.size,
        sizeMobile: (errorIcon === null || errorIcon === void 0 ? void 0 : errorIcon.sizeMobile) || defaultErrorIcon.sizeMobile
      })
    });
  }
  return /*#__PURE__*/jsxs(Picture$2, {
    className: className,
    children: [sources.map(function (_ref2, index) {
      var srcSet = _ref2.srcSet,
        type = _ref2.type,
        media = _ref2.media,
        sourceRest = _objectWithoutProperties(_ref2, _excluded2);
      return /*#__PURE__*/jsx("source", _objectSpread({
        type: type,
        media: media,
        srcSet: srcSet
      }, sourceRest), index);
    }), /*#__PURE__*/jsx("img", _objectSpread({
      alt: alt || null,
      role: alt ? null : 'presentation',
      onError: onErrorCallback,
      loading: lazy ? 'lazy' : 'eager',
      src: src
    }, rest))]
  });
};
var Picture$1 = Picture;

export { Picture$1 as default };
//# sourceMappingURL=Picture.js.map
